import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverOwnQueueApi {

    static GetUserOwnQueueItems() {
        return sendRequest(
            requestOptions(config.URL + `own/queue`,
                requestTypes.GET,
            ),
        );
    }

    static deleteOwnQueueItem(ownQueueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `own/queue/${ownQueueItemId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.queue.DELETE,
            ),
        );
    }

    static assignQueueItems(queueAssignViewModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `own/queue/assign`,
                requestTypes.PUT,
                JSON.stringify(queueAssignViewModel),
                apiConstants.successMessage.queue.UPDATE,
            ),
        );
    }

    static getShippingLocations() {
        return sendRequest(
            requestOptions(config.URL + `shipping-locations`,
                requestTypes.GET,
            ),
        );
    }
}

export const ownQueueApi = config.environment.MODE === config.modes.SERVER ? serverOwnQueueApi : serverOwnQueueApi;
